export enum Reasons {
  VENTE_PUB = 0,
  GRE_A_GRE = 1,
  BIDDIT = 2
}
